import SuspenseLoader from 'components/SuspenseLoader';
import { ComponentType, lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

const Loader = (Component: ComponentType) => {
  const WithSuspense = (props: object) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
  WithSuspense.displayName = 'WithSuspense';
  return WithSuspense;
};

const File = Loader(lazy(() => import('content/file')));

const fileRoutes = [
  {
    path: '',
    element: <Navigate to="file" replace />,
  },
  {
    path: '',
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: <File />,
      },
    ],
  },
];

export default fileRoutes;
